import { render, staticRenderFns } from "./FilterShadow2.vue?vue&type=template&id=4e701c54&"
import script from "./FilterShadow2.vue?vue&type=script&lang=ts&"
export * from "./FilterShadow2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports